import { render, staticRenderFns } from "./SignInPhone.vue?vue&type=template&id=fb4011a0&"
import script from "./SignInPhone.vue?vue&type=script&lang=ts&"
export * from "./SignInPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports